/**
 * Narrowing helpers for `AnyPlotResponse`.
 *
 * Four response shapes now answer to `/plot` - the x/y series pair (line and
 * scatter), histogram, heatmap and map - and most consumers only handle the
 * first. They used to spell that out inline as
 * `plot_type !== 'histogram' && plot_type !== 'map'`, which quietly stopped
 * being true the moment a fourth shape existed, in a dozen places at once.
 */

import type { AnyPlotResponse, PlotResponse } from './types.ts';

/** True for the x/y series shapes: line and scatter (live included). */
export function isXY(d: AnyPlotResponse): d is PlotResponse {
  return d.plot_type === 'line' || d.plot_type === 'scatter';
}
